import { useContext } from 'react';
import UserContext from '../../../context/UserContext';
import { FaBell, FaUserCircle } from 'react-icons/fa';

const DashboardHeader = ({ className, style, pageTitle }) => {
    const { user } = useContext(UserContext);

    return (
        <header
            className={`bg-white text-gray-800 p-4 flex items-center justify-between shadow-sm h-16 ${className}`}
            style={style}
        >
            <h1 className="text-2xl font-semibold text-gray-900 flex items-center">
                Admin
                {pageTitle && (
                    <span className="ml-2 mt-2 text-gray-800 text-base">
                        &nbsp;{pageTitle}
                    </span>
                )}
            </h1>

            <div className="flex items-center space-x-4">
                <div className="flex items-center text-sm text-gray-600">
                    <span className="relative flex h-2 w-2 mr-2">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                        <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
                    </span>
                    Online
                </div>

                <button
                    className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
                    aria-label="Notifications"
                    title="Notifications"
                >
                    <FaBell size={20} className="text-gray-800" />
                </button>

                {user && user.firstname && (
                    <span className="text-gray-800 text-sm bg-gray-50 p-2 rounded-md shadow-sm">
                        Welcome, {user.firstname}!
                    </span>
                )}

                <div className="relative group flex items-center">
                    <button
                        className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
                        aria-label="User Profile"
                        title="User Profile"
                    >
                        <FaUserCircle size={20} className="text-gray-800" />
                    </button>
                </div>
            </div>
        </header>
    );
};

export default DashboardHeader;
